import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d92de1d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "new-kyc-form",
  style: {"position":"relative"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","width":"100%","height":"100%"} }, null, -1))
const _hoisted_3 = { class: "d-flex flex-flow justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "150",
    height: "35",
    src: "https://bcr-img-new.s3.amazonaws.com/logo.png"
  })
], -1))
const _hoisted_5 = { class: "fs-11" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-end" }, "Licensed Financial Institution", -1))
const _hoisted_7 = { class: "d-flex text-end mt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Account 账号 #:", -1))
const _hoisted_9 = { class: "ms-2" }
const _hoisted_10 = { style: {"text-decoration":"underline"} }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center mt-11 mb-11\" data-v-d92de1d2><div class=\"fs-1\" data-v-d92de1d2> KYC EVIDENCE VERIFICATION FORM / 客户信息核实证明表 </div><div class=\"fs-1\" data-v-d92de1d2>Bacera Co Pty Ltd</div><div class=\"fs-3\" data-v-d92de1d2> For Individuals, Individual Beneficial Owners and Sole Traders </div><div class=\"fs-3\" data-v-d92de1d2>供个人，个人实益拥有者和个体经营者使用</div></div>", 1)
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, " I. Collection of Minimum KYC Information 客户基础信息采集 ", -1))
const _hoisted_13 = { style: {"width":"100%"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Surname"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "姓")
], -1))
const _hoisted_15 = { class: "kyc-input-col-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Given Name:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "名")
], -1))
const _hoisted_17 = { class: "kyc-input-col-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Prior Name"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "曾用名")
], -1))
const _hoisted_19 = { class: "kyc-input-col-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of Birth"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "出生日期")
], -1))
const _hoisted_21 = { class: "kyc-input-col-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Residential Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "居住地址")
], -1))
const _hoisted_23 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Social Media Accounts"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "社交媒体帐户 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, " [ WhatsApp/WeChat ( 微信 ) /Instagram/Telegram ]")
], -1))
const _hoisted_25 = {
  colspan: "3",
  class: "kyc-input-col-8 fs-3"
}
const _hoisted_26 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_27 = { class: "me-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "AU Citizen or hold a passport from another country?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "是否为澳大利亚联邦公民或持有他国护照?")
], -1))
const _hoisted_29 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_30 = { style: {"font-size":"12px"} }
const _hoisted_31 = { class: "d-flex align-items-center mb-3" }
const _hoisted_32 = ["checked"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "AU Citizen 澳大利亚联邦公民", -1))
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = ["checked"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Foreign Passport Holder 外国护照持有人", -1))
const _hoisted_38 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_39 = { style: {"font-size":"12px"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = {
  class: "ms-2",
  style: {"text-transform":"uppercase"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "E-mail Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "电子邮箱")
], -1))
const _hoisted_43 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Industry of Employment"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "工作行业")
], -1))
const _hoisted_45 = { class: "kyc-input-col-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_47 = { class: "kyc-input-col-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Annual Income"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "年收入")
], -1))
const _hoisted_49 = { class: "kyc-input-col-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "How might you fund your trading:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "投资资金来源")
], -1))
const _hoisted_51 = {
  key: 0,
  rowspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_52 = {
  key: 1,
  rowspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Savings and Investments"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "储蓄与投资价值")
], -1))
const _hoisted_54 = { class: "kyc-input-col-3" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Expected Nature"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "预期性质")
], -1))
const _hoisted_57 = { class: "kyc-input-col-3" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Average Trade Size"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "平均交易规模")
], -1))
const _hoisted_59 = { class: "kyc-input-col-3" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Expected Monthly Volume"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "预期月交易量")
], -1))
const _hoisted_62 = { class: "kyc-input-col-3" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Expected Frequency"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "预期交易频率")
], -1))
const _hoisted_64 = { class: "kyc-input-col-3" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Have you ever attended an education seminar or course on trading Stocks, Bonds, Contracts-for-difference, Forex, Derivatives, or other securities trading?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您是否参加过有关股票、债券、差价合约、外汇、衍生品或其他证券交易交易的教育研讨会或课程？")
], -1))
const _hoisted_66 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_67 = { class: "d-flex align-items-center mb-3" }
const _hoisted_68 = ["checked"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "YES/是", -1))
const _hoisted_70 = { class: "d-flex align-items-center" }
const _hoisted_71 = ["checked"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Do you have previous experience trading in a Stocks, Bonds, Contracts-for-difference, Forex, Derivatives, or other securities trading account?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您之前是否有过股票、债券、差价合约、外汇、衍生品或其他证券交易账户的交易经验？")
], -1))
const _hoisted_74 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_75 = { class: "d-flex align-items-center mb-3" }
const _hoisted_76 = ["checked"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "YES/是", -1))
const _hoisted_78 = { class: "d-flex align-items-center" }
const _hoisted_79 = ["checked"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Are you an employee of BCR or another Financial Company?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您是 BCR 或其他金融公司的员工吗？")
], -1))
const _hoisted_82 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_83 = { style: {"font-size":"12px"} }
const _hoisted_84 = { class: "d-flex align-items-center" }
const _hoisted_85 = ["checked"]
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Yes Please list the previous financial firms where you have been employeed / 是, 请列出您工作過的金融公司 ", -1))
const _hoisted_87 = { class: "ms-4 mt-3" }
const _hoisted_88 = { class: "mt-2" }
const _hoisted_89 = { class: "ms-3" }
const _hoisted_90 = { class: "mt-2" }
const _hoisted_91 = { class: "ms-3" }
const _hoisted_92 = { class: "mt-2" }
const _hoisted_93 = { class: "ms-3" }
const _hoisted_94 = { class: "d-flex align-items-center" }
const _hoisted_95 = ["checked"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Have you declared bankruptcy in the past 10 years?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您在过去 10 年内是否曾宣告破产？")
], -1))
const _hoisted_98 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_99 = { style: {"font-size":"12px"} }
const _hoisted_100 = { class: "d-flex align-items-center" }
const _hoisted_101 = ["checked"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Yes, please indicate the date of discharge and provide a copy of the discharge letter with your application tip. / 是的，请注明出院日期并提供出院信副本以及您的申请提示。 ", -1))
const _hoisted_103 = { class: "ms-8 mt-3 mb-3" }
const _hoisted_104 = { class: "ms-3" }
const _hoisted_105 = { class: "d-flex align-items-center" }
const _hoisted_106 = ["checked"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Are you or any person having an interest in this account a member or employee of a commodity exchange or regulatory agency?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您或任何对此账户感兴趣的人是否是商品交易所或监管机构的成员或雇员？")
], -1))
const _hoisted_109 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_110 = { style: {"font-size":"12px"} }
const _hoisted_111 = { class: "d-flex align-items-center mb-3" }
const _hoisted_112 = ["checked"]
const _hoisted_113 = { class: "ms-3" }
const _hoisted_114 = { class: "d-flex align-items-center" }
const _hoisted_115 = ["checked"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "PEP"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "政治敏感人物")
], -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "kyc-input-col-3",
  style: {"font-size":"12px"}
}, [
  /*#__PURE__*/_createTextVNode(" Are you a Politically Exposed Person (PEP)? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("您是政治公众人物 (PEP) 吗？ ")
], -1))
const _hoisted_119 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_120 = { style: {"font-size":"12px"} }
const _hoisted_121 = { class: "d-flex align-items-center mb-3" }
const _hoisted_122 = ["checked"]
const _hoisted_123 = { class: "ms-3" }
const _hoisted_124 = { class: "d-flex align-items-center" }
const _hoisted_125 = ["checked"]
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "kyc-input-col-3",
  style: {"font-size":"12px"}
}, [
  /*#__PURE__*/_createTextVNode(" Are you an immediate family member or close associate of a PEP? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("您是否有直系亲属或近亲属于政治敏感人物? ")
], -1))
const _hoisted_128 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_129 = { style: {"font-size":"12px"} }
const _hoisted_130 = { class: "d-flex align-items-center mb-3" }
const _hoisted_131 = ["checked"]
const _hoisted_132 = { class: "ms-3" }
const _hoisted_133 = { class: "d-flex align-items-center" }
const _hoisted_134 = ["checked"]
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-11 mb-11" }, null, -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "For Sole Trader Only"),
  /*#__PURE__*/_createTextVNode("/仅供个体经营者 ")
], -1))
const _hoisted_138 = { style: {"width":"100%"} }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Full Business Name"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "公司全稱")
], -1))
const _hoisted_140 = { class: "kyc-input-col-3" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Business Number"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "商務號碼")
], -1))
const _hoisted_142 = { class: "kyc-input-col-3" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Full Business Address ( No PO Box )"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "辦公地址")
], -1))
const _hoisted_144 = { class: "kyc-input-col-3" }
const _hoisted_145 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_146 = {
  class: "d-flex",
  style: {"font-size":"12px"}
}
const _hoisted_147 = { style: {"width":"50%"} }
const _hoisted_148 = { class: "d-flex align-items-center" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("City/Suburb"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("城市")
], -1))
const _hoisted_150 = { class: "ms-5 fs-3" }
const _hoisted_151 = { class: "d-flex align-items-center" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Zip/Postal"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("邮编")
], -1))
const _hoisted_153 = { class: "ms-5 fs-3" }
const _hoisted_154 = { style: {"width":"50%"} }
const _hoisted_155 = { class: "d-flex align-items-center" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("State/Territory"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("州 / 省")
], -1))
const _hoisted_157 = { class: "ms-5 fs-3" }
const _hoisted_158 = { class: "d-flex align-items-center" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Country"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("国家")
], -1))
const _hoisted_160 = { class: "ms-5 fs-3" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nature and purpose of the business relationship between BCR and the client"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "BCR与客户之间业务关系的性质和目的")
], -1))
const _hoisted_162 = { class: "kyc-input-col-3" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Reason for the client requiring our services (incl. supporting documents, e.g. overseas suppliers’ invoices)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户需要我方提供服务的原因(包括支持文件，例如海外供应商的发票)")
], -1))
const _hoisted_164 = { class: "kyc-input-col-3" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Industry in which the client operates"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户经营所属行业")
], -1))
const _hoisted_166 = { class: "kyc-input-col-3" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, " The main 3 industries in which the client’s customers operate"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户的客人所属的3个主要行业")
], -1))
const _hoisted_168 = { class: "kyc-input-col-3" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "1.", -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "2.", -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "3.", -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "An explanation of a typical service provided by the client to its customers"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户向其客人提供的一项典型服务的详细描述")
], -1))
const _hoisted_173 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-11" }, "II. Verification/ 客户信息核实", -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, " At a minimum, CLIENTS’ FULL NAME and either their DATE OF BIRTH or RESIDENTIAL ADDRESS must be verified. "),
  /*#__PURE__*/_createElementVNode("div", null, "最低限度,客户姓名和出生日期或住址必须核实.")
], -1))
const _hoisted_176 = { style: {"width":"100%"} }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Type of Document"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件类型")
], -1))
const _hoisted_178 = { class: "kyc-input-col-3" }
const _hoisted_179 = { key: 0 }
const _hoisted_180 = { key: 1 }
const _hoisted_181 = { key: 2 }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Document ID number"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件号码")
], -1))
const _hoisted_183 = { class: "kyc-input-col-3" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of birth"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "出生日期")
], -1))
const _hoisted_185 = { class: "kyc-input-col-3" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Place of residence"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "居住地址")
], -1))
const _hoisted_187 = { class: "kyc-input-col-3" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of Issue"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签发日期")
], -1))
const _hoisted_189 = { class: "kyc-input-col-3" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Expiry"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "过期日")
], -1))
const _hoisted_191 = { class: "kyc-input-col-3" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-11 mb-5" }, "Verification Method/ 核实方法", -1))
const _hoisted_193 = { style: {"width":"100%"} }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Verification Method"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "核实方法")
], -1))
const _hoisted_195 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_196 = { class: "d-flex align-items-center mb-3" }
const _hoisted_197 = ["checked"]
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Traditional Verification/传统核实", -1))
const _hoisted_199 = { class: "d-flex align-items-center" }
const _hoisted_200 = ["checked"]
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, "Electronic Verification/电子核实", -1))
const _hoisted_202 = { class: "d-flex align-items-center ms-2" }
const _hoisted_203 = ["checked"]
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "LAB group", -1))
const _hoisted_205 = { class: "d-flex align-items-center ms-2 me-2" }
const _hoisted_206 = ["checked"]
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Data Zoo", -1))
const _hoisted_208 = { class: "d-flex align-items-center ms-2 me-2" }
const _hoisted_209 = ["checked"]
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Refinitiv", -1))
const _hoisted_211 = {
  class: "mt-7",
  style: {"width":"100%"}
}
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "text-center fw-bold" }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "kyc-label-col-5",
    style: {"font-size":"14px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Traditional Verification/传统核实")
  ]),
  /*#__PURE__*/_createElementVNode("td", {
    class: "kyc-label-col-5",
    style: {"font-size":"14px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Electronic Verification/电子核实")
  ])
], -1))
const _hoisted_213 = {
  class: "kyc-input-col-5",
  style: {"font-size":"12px"}
}
const _hoisted_214 = { class: "d-flex align-items-center" }
const _hoisted_215 = ["checked"]
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Verification method 1/核实方法1", -1))
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a primary photographic identification document/ "),
  /*#__PURE__*/_createElementVNode("div", null, "首要的含照片身份证明文件的原始件或经认证的复印/")
], -1))
const _hoisted_218 = { class: "d-flex align-items-center mt-3" }
const _hoisted_219 = ["checked"]
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Verification method 2/核实方法2", -1))
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a primary non-photographic identification document; AND/OR "),
  /*#__PURE__*/_createElementVNode("div", null, " 首要的不含照片的身份证明文件原始件或经认证的复印件; 以及/或 "),
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a secondary identification document; "),
  /*#__PURE__*/_createElementVNode("div", null, "二级身份证明文件的原始件或经认证的复印;")
], -1))
const _hoisted_222 = {
  class: "kyc-input-col-5",
  style: {"font-size":"12px"}
}
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("Verify information collected about a client from: "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("收集的关于核实客户信息来源于:")
  ])
], -1))
const _hoisted_224 = { class: "d-flex align-items-center" }
const _hoisted_225 = ["checked"]
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createTextVNode(" Reliable and independent documentation "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("可靠且独立的文件 ")
], -1))
const _hoisted_227 = { class: "d-flex align-items-center mt-3" }
const _hoisted_228 = ["checked"]
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Reliable and independent electronic data from at least two (2) separate data source "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("来自至少两 (2) 个单独数据源的可靠且独立的电子数据 ")
  ])
], -1))
const _hoisted_230 = { class: "d-flex align-items-center mt-3" }
const _hoisted_231 = ["checked"]
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("A combination of both of the above "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("上面两者结合")
  ])
], -1))
const _hoisted_233 = {
  class: "mt-7",
  style: {"width":"100%"}
}
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Compliance Notes"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "合规部门备注")
], -1))
const _hoisted_235 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"16px","color":"#900000"}
}
const _hoisted_236 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-12\" data-v-d92de1d2><div class=\"mb-5\" style=\"font-weight:bold;\" data-v-d92de1d2><div data-v-d92de1d2> Where a client cannot provide satisfactory evidence of identity: </div><div data-v-d92de1d2>当客户无法提供令人满意的身份证明时：</div></div><div class=\"mb-5\" data-v-d92de1d2><div data-v-d92de1d2> Where a client does not possess and is unable to obtain the necessary information or evidence of identity, then in limited and exceptional cases, we may use alternative identity proofing process, which are commensurate with our risk-based systems and controls. </div></div><div class=\"mb-5\" data-v-d92de1d2><div data-v-d92de1d2> In these limited and exceptional cases, the matter will be referred to the AML/CTF compliance officer who may accept a self-attestation from the client, if they are not aware that the self-attestation is incorrect or misleading. The AML/CTF compliance officer will also designate the client as being high risk and will implement the appropriate level of ongoing customer due diligence procedures which is commensurate with a high risk client. </div></div><div class=\"mb-5\" data-v-d92de1d2><div data-v-d92de1d2> 如果客户不拥有且无法获得必要的身份信息或证明，那么在有限和例外的情况下，我们可能会使用替代性的身份证明流程，该流程与基于风险的系统和控制措施相符。 </div></div><div class=\"mb-5\" data-v-d92de1d2><div data-v-d92de1d2> 在这些有限和例外的情况下，此事将转给可能接受客户自我证明的AML / CTF合规官員, 如果他们不知道该自我证明是不正确或具有误导性。AML / CTF合规官还将指定客户为高风险客户，并将实施与高风险客户相对应的适当级别的持续客户尽职调查程序。 </div></div></div>", 1)
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-11 mb-9",
  style: {"position":"relative"}
}, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-center",
    style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)","background-color":"white","padding":"0px 10px 0px 18px"}
  }, [
    /*#__PURE__*/_createElementVNode("strong", null, "For Office Use Only/本公司专用（请勿填写）")
  ])
], -1))
const _hoisted_238 = { class: "d-flex justify-content-around" }
const _hoisted_239 = { style: {"width":"48%"} }
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Admin Staff Member"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "办公室员工")
], -1))
const _hoisted_241 = { class: "kyc-input-col-3" }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_243 = { class: "kyc-input-col-3" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Signature"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签名")
], -1))
const _hoisted_245 = { class: "kyc-input-col-3" }
const _hoisted_246 = ["src"]
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date Signed"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签字日期")
], -1))
const _hoisted_248 = { class: "kyc-input-col-3" }
const _hoisted_249 = { style: {"width":"48%"} }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Compliance Staff Member"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "合规部门员工")
], -1))
const _hoisted_251 = { class: "kyc-input-col-3" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_253 = { class: "kyc-input-col-3" }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Signature"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签名")
], -1))
const _hoisted_255 = { class: "kyc-input-col-3" }
const _hoisted_256 = ["src"]
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date Signed"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签字日期")
], -1))
const _hoisted_258 = { class: "kyc-input-col-3" }
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-11 mb-11" }, null, -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, "COPY OF SUPPORTING DOCUMENTATION"),
  /*#__PURE__*/_createElementVNode("div", null, "支持性⽂件复印件")
], -1))
const _hoisted_261 = { width: "100%" }
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Type of Document"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件类型")
], -1))
const _hoisted_263 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_264 = { class: "d-flex align-items-center mb-3" }
const _hoisted_265 = ["checked"]
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Passport (Country of Origin)/护照（原籍国）", -1))
const _hoisted_267 = { class: "d-flex align-items-center mb-3" }
const _hoisted_268 = ["checked"]
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Photo ID / DL (Country of Origin)/含照片身份证件/驾照（原籍国） ", -1))
const _hoisted_270 = { class: "d-flex align-items-center" }
const _hoisted_271 = ["checked"]
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Financial Statement/Utility Bill/Government Document/ 财务证明/水电费账单/政府文件 ", -1))
const _hoisted_273 = /*#__PURE__*/_createStaticVNode("<hr class=\"mt-11 mb-11\" data-v-d92de1d2><div class=\"my-8\" data-v-d92de1d2><div class=\"text-xs font-semibold mb-6 tracking-widerr\" data-v-d92de1d2><div data-v-d92de1d2> You must verify the CLIENT’S FULL NAME and either their DATE OF BIRTH or RESIDENTIAL ADDRESS using: </div><div data-v-d92de1d2>您必须利用以下资料确认客户姓名和出生日期或住址信息:</div></div><div class=\"p-4\" style=\"border:1px solid lightgray;\" data-v-d92de1d2><div class=\"text-xs font-semibold mb-4 tracking-widerr\" data-v-d92de1d2><div data-v-d92de1d2> AN ORIGINAL OR CERTIFIED COPY OF A PRIMARY PHOTOGRAPHIC IDENTIFICATION DOCUMENT </div><div data-v-d92de1d2>一份含照⽚的首要身份证明⽂件原始件或认证的复印件</div></div><div class=\"px-8\" data-v-d92de1d2><ul class=\"list-disc list-outside text-3xs\" data-v-d92de1d2><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2> A license or permit issued under a law of a State or Territory or equivalent authority of a foreign country for the purpose of driving a vehicle that contains a photograph of the person in whose name the document is issued; </div><div data-v-d92de1d2> 州或领地或其他外国的政府或同等权威机构颁发的含申请人姓名及照⽚的用于驾驶车辆的许可证件; </div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2>a passport issued by the Commonwealth;</div><div data-v-d92de1d2>联邦颁发的护照;</div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2> a passport or a similar document issued for the purpose of international travel, that: </div><div data-v-d92de1d2>护照或其他和护照性质一样用于国际旅行的⽂件:</div><div class=\"px-8\" data-v-d92de1d2><ol class=\"list-decimal list-outside text-3xs\" data-v-d92de1d2><li data-v-d92de1d2><div data-v-d92de1d2> Contains a photograph and the signature of the person in whose the document is issued; </div><div data-v-d92de1d2>签发的⽂件需包含申请人照⽚和签名;</div></li><li data-v-d92de1d2><div data-v-d92de1d2> is issued by a foreign government, the United Nations or an agency of the United Nations; and </div><div data-v-d92de1d2>由外国政府, 联合国或联合国所属机构颁发, 以及</div></li><li data-v-d92de1d2><div data-v-d92de1d2> if it is written in a language that is not understood by the person carrying out the the verification – is accompanied by an English translation prepared by an accredit translator. </div><div data-v-d92de1d2> 如果进行验证的人对⽂件所用语言并不了解或认知,需由授权翻译机构翻译成英⽂. </div></li></ol></div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2> A card issued under the law of a State or Territory for the purpose of proving the person’s age which contains a photograph of the person in whose name the document is issued. </div><div data-v-d92de1d2> 按照州或领地法律颁发的用于证明申请人年龄的包含申请人照⽚及姓名的证件. </div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2> A national identity card issued for the purpose of identification, that: </div><div data-v-d92de1d2>用于识别身份的国民身份证:</div><div class=\"px-8\" data-v-d92de1d2><ol class=\"list-decimal list-outside text-3xs mx-2\" data-v-d92de1d2><li data-v-d92de1d2><div data-v-d92de1d2> Contains a photograph and a signature of the person in whose name the document is issued; </div><div data-v-d92de1d2>包含申请人照⽚和签名;</div></li><li data-v-d92de1d2><div data-v-d92de1d2> is issued by a foreign government, the United Nations or an agency of the United Nations if it is written in a language that is not understood by the person carrying out the verification – is accompanied by an English translation prepared by an accredit translator. </div><div data-v-d92de1d2> 由外国政府, 联合国或联合国所属机构颁发, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂. </div></li></ol></div></li></ul></div></div></div><div class=\"text-xs font-semibold text-center w-full tracking-widerr mb-7\" data-v-d92de1d2> OR / 或 </div><div class=\"p-4\" style=\"border:1px solid lightgray;\" data-v-d92de1d2><div class=\"text-xs font-semibold mb-4 tracking-widerr\" data-v-d92de1d2><div data-v-d92de1d2> AN ORIGINAL OR CERTIFIED COPY OF A PRIMARY PHOTOGRAPHIC IDENTIFICATION DOCUMENT </div><div data-v-d92de1d2>一份含照⽚的首要身份证明⽂件原始件或认证的复印件</div></div><div class=\"px-8\" data-v-d92de1d2><ul class=\"list-disc list-outside text-3xs\" data-v-d92de1d2><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2> A birth certificate or birth extract issued by a State or Territory; </div><div data-v-d92de1d2>由州或领地颁发的出生证明或出生信息摘要;</div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2>a citizenship certificate issued by the Commonwealth;</div><div data-v-d92de1d2>由联邦颁发的公民证明;</div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2> a citizenship certificate issued by a foreign government that, if it is written in a language that is not understood by the person carrying out the verification, is accompanied by an English translation prepared by an accredited translator; </div><div data-v-d92de1d2> 由外国政府颁发的公民证明, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂. </div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2> a birth certificate issued by a foreign government, the United Nations or an agency of the United Nations that, if it is written in a language that is not understood by the person carrying out the verification, is accompanied by an English translation prepared by an accredited translator; </div><div data-v-d92de1d2> 由外国政府,联合国或联合国所属机构颁发的出生证明, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂; </div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2> a pension card issued by Centrelink that entitles the person in whose name the card is issued, to financial benefits. </div><div data-v-d92de1d2> 由centrelink发出的, 基于财务效益, 授予申请人的包含申请人姓名的养⽼金卡. </div></li></ul></div><div class=\"text-xs font-semibold text-center w-full my-8 tracking-widerr\" data-v-d92de1d2> AND / 以及 </div><div class=\"text-xs font-semibold mb-4 tracking-widerr\" data-v-d92de1d2><div data-v-d92de1d2> AN ORIGINAL OR CERTIFIED COPY OF A SECONDARY IDENTIFICATION DOCUMENT </div><div data-v-d92de1d2>一份含照⽚的二级身份证明⽂件原始件或认证的复印件</div></div><div class=\"px-8\" data-v-d92de1d2><ul class=\"list-disc list-outside text-3xs\" data-v-d92de1d2><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2>A notice that / 一份声明:</div><div class=\"px-8\" data-v-d92de1d2><ol class=\"list-decimal list-outside text-3xs\" data-v-d92de1d2><li data-v-d92de1d2><div data-v-d92de1d2> was issued to an individual by the Commonwealth, a State or Territory within the preceding twelve months; </div><div data-v-d92de1d2>由聯邦或州或領地在前12個月內簽發給個人的;</div></li><li data-v-d92de1d2><div data-v-d92de1d2> contains the name of the individual and his or her residential address; and </div><div data-v-d92de1d2>包含個人姓名和他/她的住址信息; 以及</div></li><li data-v-d92de1d2><div data-v-d92de1d2> records the provision of financial benefits to the individual under a law of the Commonwealth, State or Territory (as the case may be); </div><div data-v-d92de1d2> 根據聯邦或州或領地法律提供個人財務收益的記錄(視情況而定); </div></li></ol></div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2>A notice that / 一份声明:</div><div class=\"px-8\" data-v-d92de1d2><ol class=\"list-decimal list-outside text-3xs\" data-v-d92de1d2><li data-v-d92de1d2><div data-v-d92de1d2> was issued to an individual by the Australian Taxation Office within the preceding 12 months; </div><div data-v-d92de1d2>由澳大利亞稅務機構在前12個月內簽發給個人的;</div></li><li data-v-d92de1d2><div data-v-d92de1d2> contains the name of the individual and his or her residential address; and </div><div data-v-d92de1d2>包含個人姓名和他/她的住址信息; 以及</div></li><li data-v-d92de1d2><div data-v-d92de1d2> records a debt payable to or by the individual by or to (respectively) the Commonwealth under Commonwealth law relating to taxation; </div><div data-v-d92de1d2>根據聯邦稅務相關法律關於個人債務支付的記錄;</div></li></ol></div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2>A notice that / 一份声明:</div><div class=\"px-8\" data-v-d92de1d2><ol class=\"list-decimal list-outside text-3xs\" data-v-d92de1d2><li data-v-d92de1d2><div data-v-d92de1d2> was issued to an individual by a local government body or utilities provider within the preceding three months; </div><div data-v-d92de1d2>由當地政府或公共事業機構在前3個月內簽發給個人的;</div></li><li data-v-d92de1d2><div data-v-d92de1d2> contains the name of the individual and his or her residential address; and </div><div data-v-d92de1d2>包含個人姓名和他/她的住址信息; 以及</div></li><li data-v-d92de1d2><div data-v-d92de1d2> records the provision of services by that local government body or utilities provider to that address or to that person. </div><div data-v-d92de1d2> 由當地政府機構或公共事業機構對該住址或個人提供的服務記錄. </div></li></ol></div></li><li class=\"mb-2\" data-v-d92de1d2><div data-v-d92de1d2>A notice that / 一份声明:</div><div class=\"px-8\" data-v-d92de1d2><ol class=\"list-decimal list-outside text-3xs\" data-v-d92de1d2><li data-v-d92de1d2><div data-v-d92de1d2> was issued to a person by a school principal within the preceding three months; </div><div data-v-d92de1d2>由學校校長在前3個月之內簽發給個人的；</div></li><li data-v-d92de1d2><div data-v-d92de1d2> contains the name of the person and his or her residential address; and </div><div data-v-d92de1d2>包含個人姓名和他/她的住址信息; 以及</div></li><li data-v-d92de1d2><div data-v-d92de1d2> records the period of time that the person attended at the school. </div><div data-v-d92de1d2>提供個人在校時間的記錄.</div></li></ol></div></li></ul></div></div><footer class=\"text-center mt-11\" data-v-d92de1d2><p data-v-d92de1d2>L1, 6-10 O’Connell Street Sydney, NSW 2000 Australia</p><p data-v-d92de1d2>Bacera Co Pty Ltd | AU Company No. | License No.</p></footer>", 5)

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewKycForm',
  props: {
    kycInfos: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();


// watch(
//   () => props.kycInfos,
//   () => {
//     item.value = {
//       ...props.verificationDetails?.financial,
//     };
//   }
// );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, "   " + _toDisplayString(props.kycInfos.accountNumber) + "   ", 1)
          ])
        ])
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", null, [
      _hoisted_12,
      _createElementVNode("table", _hoisted_13, [
        _createElementVNode("tr", null, [
          _hoisted_14,
          _createElementVNode("td", _hoisted_15, _toDisplayString(props.kycInfos.lastName), 1),
          _hoisted_16,
          _createElementVNode("td", _hoisted_17, _toDisplayString(props.kycInfos.firstName), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_18,
          _createElementVNode("td", _hoisted_19, _toDisplayString(props.kycInfos.priorName), 1),
          _hoisted_20,
          _createElementVNode("td", _hoisted_21, _toDisplayString(props.kycInfos.birthday), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_22,
          _createElementVNode("td", _hoisted_23, _toDisplayString(props.kycInfos.address), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_24,
          _createElementVNode("td", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kycInfos.socialMediaTypes, (type, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (type.account != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("fields." + type.name)) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(type.account), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_28,
          _createElementVNode("td", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.citizen?.toLowerCase() == 'au'
                }, null, 8, _hoisted_32),
                _hoisted_33
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: 
                        !!props.kycInfos.citizen &&
                        props.kycInfos.citizen?.toLowerCase() != 'au'
                      
                    }, null, 8, _hoisted_36),
                    _hoisted_37
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("td", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createTextVNode(" Please provide details "),
              _hoisted_40,
              _createTextVNode("请提供细节: "),
              _createElementVNode("strong", _hoisted_41, _toDisplayString(props.kycInfos.citizen) + " Citizen", 1)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_42,
          _createElementVNode("td", _hoisted_43, _toDisplayString(props.kycInfos.email), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_44,
          _createElementVNode("td", _hoisted_45, _toDisplayString(props.kycInfos.industry), 1),
          _hoisted_46,
          _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.$t("fields." + props.kycInfos.occupation)), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_48,
          _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.$t("fields.range_" + props.kycInfos.annualIncome)), 1),
          _hoisted_50,
          (props.kycInfos.sourceOfFunds != '')
            ? (_openBlock(), _createElementBlock("td", _hoisted_51, _toDisplayString(props.kycInfos.sourceOfFunds), 1))
            : (_openBlock(), _createElementBlock("td", _hoisted_52, _toDisplayString(props.kycInfos.fund2), 1))
        ]),
        _createElementVNode("tr", null, [
          _hoisted_53,
          _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.$t("fields.range_" + props.kycInfos.netWorth)), 1)
        ]),
        (
            props.kycInfos.transaction1 !== '' &&
            props.kycInfos.transaction1 !== null &&
            props.kycInfos.transaction1 !== undefined
          )
          ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("td", _hoisted_57, _toDisplayString(props.kycInfos.nature), 1),
              _hoisted_58,
              _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.$t("type.verification.expected." + props.kycInfos.transaction1)), 1)
            ]))
          : _createCommentVNode("", true),
        (
            props.kycInfos.transaction2 !== '' &&
            props.kycInfos.transaction2 !== null &&
            props.kycInfos.transaction2 !== undefined
          )
          ? (_openBlock(), _createElementBlock("tr", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.$t("type.verification.expected." + props.kycInfos.transaction2)), 1),
              _hoisted_63,
              _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.$t("type.verification.expected." + props.kycInfos.transaction3)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("tr", null, [
          _hoisted_65,
          _createElementVNode("td", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("input", {
                class: "me-4",
                type: "checkbox",
                checked: props.kycInfos.bg1 == 0
              }, null, 8, _hoisted_68),
              _hoisted_69
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("input", {
                class: "me-4",
                type: "checkbox",
                checked: props.kycInfos.bg1 == 1
              }, null, 8, _hoisted_71),
              _hoisted_72
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_73,
          _createElementVNode("td", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("input", {
                class: "me-4",
                type: "checkbox",
                checked: props.kycInfos.bg2 == 0
              }, null, 8, _hoisted_76),
              _hoisted_77
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("input", {
                class: "me-4",
                type: "checkbox",
                checked: props.kycInfos.bg2 == 1
              }, null, 8, _hoisted_79),
              _hoisted_80
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_81,
          _createElementVNode("td", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp1 == 0
                }, null, 8, _hoisted_85),
                _hoisted_86
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", _hoisted_88, [
                    _createTextVNode(" Employer/公司 : "),
                    _createElementVNode("span", _hoisted_89, _toDisplayString(props.kycInfos.exp1Employer), 1)
                  ]),
                  _createElementVNode("li", _hoisted_90, [
                    _createTextVNode(" Position/職位 : "),
                    _createElementVNode("span", _hoisted_91, _toDisplayString(props.kycInfos.exp1Position), 1)
                  ]),
                  _createElementVNode("li", _hoisted_92, [
                    _createTextVNode(" Remuneration/报酬 : "),
                    _createElementVNode("span", _hoisted_93, _toDisplayString(props.kycInfos.exp1Remuneration), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp1 == 1
                }, null, 8, _hoisted_95),
                _hoisted_96
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_97,
          _createElementVNode("td", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp2 == 0
                }, null, 8, _hoisted_101),
                _hoisted_102
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createTextVNode(" Date:"),
                _createElementVNode("span", _hoisted_104, _toDisplayString(props.kycInfos.exp2More), 1)
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp2 == 1
                }, null, 8, _hoisted_106),
                _hoisted_107
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_108,
          _createElementVNode("td", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp3 == 0
                }, null, 8, _hoisted_112),
                _createElementVNode("div", null, [
                  _createTextVNode(" Yes, please provide name(s) of Exchange or Agency. / 是, 请提供交易所或机构的名称:"),
                  _createElementVNode("span", _hoisted_113, _toDisplayString(props.kycInfos.exp3More), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp3 == 1
                }, null, 8, _hoisted_115),
                _hoisted_116
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_117,
          _hoisted_118,
          _createElementVNode("td", _hoisted_119, [
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp4 == 0
                }, null, 8, _hoisted_122),
                _createElementVNode("div", null, [
                  _createTextVNode(" Yes Please provide details/是, 请提供细节:"),
                  _createElementVNode("span", _hoisted_123, _toDisplayString(props.kycInfos.exp4More), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp4 == 1
                }, null, 8, _hoisted_125),
                _hoisted_126
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_127,
          _createElementVNode("td", _hoisted_128, [
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp5 == 0
                }, null, 8, _hoisted_131),
                _createElementVNode("div", null, [
                  _createTextVNode(" Yes Please provide details/是, 请提供细节:"),
                  _createElementVNode("span", _hoisted_132, _toDisplayString(props.kycInfos.exp5More), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.exp5 == 1
                }, null, 8, _hoisted_134),
                _hoisted_135
              ])
            ])
          ])
        ])
      ]),
      _hoisted_136,
      _hoisted_137,
      _createElementVNode("table", _hoisted_138, [
        _createElementVNode("tr", null, [
          _hoisted_139,
          _createElementVNode("td", _hoisted_140, _toDisplayString(props.kycInfos.businessName), 1),
          _hoisted_141,
          _createElementVNode("td", _hoisted_142, _toDisplayString(props.kycInfos.businessNumber), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_143,
          _createElementVNode("td", _hoisted_144, _toDisplayString(props.kycInfos.businessAddress), 1),
          _createElementVNode("td", _hoisted_145, [
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("div", _hoisted_147, [
                _createElementVNode("div", _hoisted_148, [
                  _hoisted_149,
                  _createElementVNode("div", _hoisted_150, _toDisplayString(props.kycInfos.businessCity), 1)
                ]),
                _createElementVNode("div", _hoisted_151, [
                  _hoisted_152,
                  _createElementVNode("div", _hoisted_153, _toDisplayString(props.kycInfos.businessZipCode), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_154, [
                _createElementVNode("div", _hoisted_155, [
                  _hoisted_156,
                  _createElementVNode("div", _hoisted_157, _toDisplayString(props.kycInfos.businessState), 1)
                ]),
                _createElementVNode("div", _hoisted_158, [
                  _hoisted_159,
                  _createElementVNode("div", _hoisted_160, _toDisplayString(props.kycInfos.businessCountry), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_161,
          _createElementVNode("td", _hoisted_162, _toDisplayString(props.kycInfos.businessCompanyPurposeBetweenUs), 1),
          _hoisted_163,
          _createElementVNode("td", _hoisted_164, _toDisplayString(props.kycInfos.businessServiceRequireReason), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_165,
          _createElementVNode("td", _hoisted_166, _toDisplayString(props.kycInfos.businessIndustry), 1),
          _hoisted_167,
          _createElementVNode("td", _hoisted_168, [
            _createElementVNode("div", null, [
              _hoisted_169,
              _createTextVNode(_toDisplayString(props.kycInfos.businessClientIndustry1), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_170,
              _createTextVNode(_toDisplayString(props.kycInfos.businessClientIndustry2), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_171,
              _createTextVNode(_toDisplayString(props.kycInfos.businessClientIndustry3), 1)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_172,
          _createElementVNode("td", _hoisted_173, _toDisplayString(props.kycInfos.businessService), 1)
        ])
      ]),
      _hoisted_174,
      _hoisted_175,
      _createElementVNode("table", _hoisted_176, [
        _createElementVNode("tr", null, [
          _hoisted_177,
          _createElementVNode("td", _hoisted_178, [
            (props.kycInfos.idType == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_179, "Passport"))
              : _createCommentVNode("", true),
            (props.kycInfos.idType == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_180, "Driver's License"))
              : _createCommentVNode("", true),
            (props.kycInfos.idType == 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_181, "Government ID"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_182,
          _createElementVNode("td", _hoisted_183, _toDisplayString(props.kycInfos.idNumber), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_184,
          _createElementVNode("td", _hoisted_185, _toDisplayString(props.kycInfos.birthday), 1),
          _hoisted_186,
          _createElementVNode("td", _hoisted_187, _toDisplayString(props.kycInfos.address), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_188,
          _createElementVNode("td", _hoisted_189, _toDisplayString(props.kycInfos.idIssuedOn), 1),
          _hoisted_190,
          _createElementVNode("td", _hoisted_191, _toDisplayString(props.kycInfos.idExpireOn), 1)
        ])
      ]),
      _hoisted_192,
      _createElementVNode("table", _hoisted_193, [
        _createElementVNode("tr", null, [
          _hoisted_194,
          _createElementVNode("td", _hoisted_195, [
            _createElementVNode("div", _hoisted_196, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: 
                  props.kycInfos.electronicOrTraditional == 'traditional'
                
              }, null, 8, _hoisted_197),
              _hoisted_198
            ]),
            _createElementVNode("div", _hoisted_199, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: 
                  props.kycInfos.electronicOrTraditional == 'electronic'
                
              }, null, 8, _hoisted_200),
              _hoisted_201,
              _createTextVNode(" ( "),
              _createElementVNode("div", _hoisted_202, [
                _createElementVNode("input", {
                  class: "me-2",
                  type: "checkbox",
                  checked: props.kycInfos.electronicSourceOption == 'labGroup'
                }, null, 8, _hoisted_203),
                _hoisted_204
              ]),
              _createElementVNode("div", _hoisted_205, [
                _createElementVNode("input", {
                  class: "me-2",
                  type: "checkbox",
                  checked: props.kycInfos.electronicSourceOption == 'dataZoo'
                }, null, 8, _hoisted_206),
                _hoisted_207
              ]),
              _createElementVNode("div", _hoisted_208, [
                _createElementVNode("input", {
                  class: "me-2",
                  type: "checkbox",
                  checked: 
                    props.kycInfos.electronicSourceOption == 'refinitiv'
                  
                }, null, 8, _hoisted_209),
                _hoisted_210
              ]),
              _createTextVNode(" ) ")
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_211, [
        _hoisted_212,
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_213, [
            _createElementVNode("div", _hoisted_214, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.traditionalOption == 'traditional1'
              }, null, 8, _hoisted_215),
              _hoisted_216
            ]),
            _hoisted_217,
            _createElementVNode("div", _hoisted_218, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.traditionalOption == 'traditional2'
              }, null, 8, _hoisted_219),
              _hoisted_220
            ]),
            _hoisted_221
          ]),
          _createElementVNode("td", _hoisted_222, [
            _hoisted_223,
            _createElementVNode("div", _hoisted_224, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.electronicOption == '0'
              }, null, 8, _hoisted_225),
              _hoisted_226
            ]),
            _createElementVNode("div", _hoisted_227, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.electronicOption == '1'
              }, null, 8, _hoisted_228),
              _hoisted_229
            ]),
            _createElementVNode("div", _hoisted_230, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.electronicOption == '2'
              }, null, 8, _hoisted_231),
              _hoisted_232
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_233, [
        _createElementVNode("tr", null, [
          _hoisted_234,
          _createElementVNode("td", _hoisted_235, _toDisplayString(props.kycInfos.complianceNote), 1)
        ])
      ]),
      _hoisted_236
    ]),
    _hoisted_237,
    _createElementVNode("div", _hoisted_238, [
      _createElementVNode("table", _hoisted_239, [
        _createElementVNode("tr", null, [
          _hoisted_240,
          _createElementVNode("td", _hoisted_241, _toDisplayString(props.kycInfos.staffName), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_242,
          _createElementVNode("td", _hoisted_243, _toDisplayString(props.kycInfos.staffPosition), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_244,
          _createElementVNode("td", _hoisted_245, [
            _createElementVNode("img", {
              src: props.kycInfos.staffSignature,
              height: "80",
              alt: ""
            }, null, 8, _hoisted_246)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_247,
          _createElementVNode("td", _hoisted_248, _toDisplayString(props.kycInfos.staffSignedOn), 1)
        ])
      ]),
      _createElementVNode("table", _hoisted_249, [
        _createElementVNode("tr", null, [
          _hoisted_250,
          _createElementVNode("td", _hoisted_251, _toDisplayString(props.kycInfos.complianceName), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_252,
          _createElementVNode("td", _hoisted_253, _toDisplayString(props.kycInfos.compliancePosition), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_254,
          _createElementVNode("td", _hoisted_255, [
            _createElementVNode("img", {
              src: props.kycInfos.complianceSignature,
              height: "80",
              alt: ""
            }, null, 8, _hoisted_256)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_257,
          _createElementVNode("td", _hoisted_258, _toDisplayString(props.kycInfos.complianceSignedOn), 1)
        ])
      ])
    ]),
    _hoisted_259,
    _hoisted_260,
    _createElementVNode("table", _hoisted_261, [
      _createElementVNode("tr", null, [
        _hoisted_262,
        _createElementVNode("td", _hoisted_263, [
          _createElementVNode("div", _hoisted_264, [
            _createElementVNode("input", {
              class: "me-2",
              type: "checkbox",
              checked: props.kycInfos.idType == '3'
            }, null, 8, _hoisted_265),
            _hoisted_266
          ]),
          _createElementVNode("div", _hoisted_267, [
            _createElementVNode("input", {
              class: "me-2",
              type: "checkbox",
              checked: props.kycInfos.idType == '2'
            }, null, 8, _hoisted_268),
            _hoisted_269
          ]),
          _createElementVNode("div", _hoisted_270, [
            _createElementVNode("input", {
              class: "me-2",
              type: "checkbox",
              checked: props.kycInfos.idType == '1'
            }, null, 8, _hoisted_271),
            _hoisted_272
          ])
        ])
      ])
    ]),
    _hoisted_273
  ]))
}
}

})